// src/theme/ThemeContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();
const STORAGE_KEY = "su.theme";

export function ThemeProvider({ children }) {
    // ✅ 로컬스토리지 값이 없으면 'dark'로 시작
    const [theme, setTheme] = useState(() => {
        try { return localStorage.getItem(STORAGE_KEY) || "light"; }
        catch { return "light"; }
    });

    useEffect(() => {
        document.documentElement.dataset.theme = theme;
        try { localStorage.setItem(STORAGE_KEY, theme); } catch { }
        window.dispatchEvent(new CustomEvent("su:theme:changed", { detail: theme }));
    }, [theme]);

    const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

    return (
        <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
